// ─── Initial State ──────────────────────────────────────────────────
export const initialGameState = {
    gameId: null,
    phase: 'idle',
    players: [],
    localPlayerIndex: 0,
    currentTurnIndex: 0,
    hand: [],
    trickCards: [],
    leadSuit: null,
    trickWinnerId: null,
    showingCollection: false,
    hoveredCardIndex: -1,
    selectedCardIndex: -1,
    turnTimeRemainingMs: 30_000,
    turnTotalMs: 30_000,
    roundNumber: 1,
    roundResults: null,
    winnerId: null,
    finalScores: null,
    roundHistory: [],
    error: null,
};
// ─── Actions (pure state transitions) ──────────────────────────────
export function setGameStarted(_state, gameId, players, localPlayerIndex) {
    return {
        ...initialGameState,
        gameId,
        players,
        localPlayerIndex,
        // Round 1 is an open round — no calling phase, straight to playing
        phase: 'playing',
        roundNumber: 1,
    };
}
export function setHand(state, hand) {
    return { ...state, hand };
}
export function setCallPhase(state, currentTurnIndex) {
    return { ...state, phase: 'calling', currentTurnIndex };
}
export function setPlayPhase(state, currentTurnIndex) {
    return { ...state, phase: 'playing', currentTurnIndex, trickCards: [], leadSuit: null };
}
export function applyCallMade(state, playerId, call) {
    const players = state.players.map((p) => (p.id === playerId ? { ...p, call } : p));
    return { ...state, players };
}
export function applyCardPlayed(state, playerId, card) {
    const trickCards = [...state.trickCards, { playerId, card }];
    const leadSuit = state.trickCards.length === 0 ? card.suit : state.leadSuit;
    // Remove card from hand if it's the local player
    const localPlayer = state.players[state.localPlayerIndex];
    let hand = state.hand;
    if (localPlayer && playerId === localPlayer.id) {
        hand = hand.filter((c) => !(c.suit === card.suit && c.rank === card.rank));
    }
    return { ...state, trickCards, leadSuit, hand, selectedCardIndex: -1, hoveredCardIndex: -1 };
}
export function applyTrickWon(state, winnerId) {
    const players = state.players.map((p) => p.id === winnerId ? { ...p, tricksWon: p.tricksWon + 1 } : p);
    return { ...state, players, trickWinnerId: winnerId, showingCollection: true };
}
export function clearTrick(state) {
    return {
        ...state,
        trickCards: [],
        leadSuit: null,
        trickWinnerId: null,
        showingCollection: false,
    };
}
export function setRoundEnd(state, results) {
    const players = state.players.map((p) => {
        const r = results.find((res) => res.playerId === p.id);
        return r ? { ...p, totalScore: r.totalScore, tricksWon: 0, call: null } : p;
    });
    return {
        ...state,
        phase: 'roundEnd',
        roundResults: results,
        players,
        roundHistory: [...state.roundHistory, results],
    };
}
export function setNewRound(state, roundNumber, currentTurnIndex) {
    return {
        ...state,
        phase: 'calling',
        roundNumber,
        currentTurnIndex,
        roundResults: null,
        trickCards: [],
        leadSuit: null,
        trickWinnerId: null,
        showingCollection: false,
        hoveredCardIndex: -1,
        selectedCardIndex: -1,
    };
}
export function setGameOver(state, winnerId, finalScores) {
    return { ...state, phase: 'gameOver', winnerId, finalScores };
}
export function setTurnTimer(state, remainingMs) {
    return { ...state, turnTimeRemainingMs: remainingMs };
}
export function setCurrentTurn(state, currentTurnIndex) {
    return { ...state, currentTurnIndex };
}
export function setHoveredCard(state, index) {
    return { ...state, hoveredCardIndex: index };
}
export function setSelectedCard(state, index) {
    return { ...state, selectedCardIndex: index };
}
export function setError(state, error) {
    return { ...state, error };
}
export function setPlayerDisconnected(state, playerId) {
    const players = state.players.map((p) => (p.id === playerId ? { ...p, isConnected: false } : p));
    return { ...state, players };
}
export function setPlayerReconnected(state, playerId) {
    const players = state.players.map((p) => p.id === playerId ? { ...p, isConnected: true, isAI: false } : p);
    return { ...state, players };
}
export function setPlayerReplacedByAI(state, playerId) {
    const players = state.players.map((p) => p.id === playerId ? { ...p, isAI: true, isConnected: false } : p);
    return { ...state, players };
}
export function resetGame() {
    return { ...initialGameState };
}
//# sourceMappingURL=gameStore.js.map